import { IStrings } from 'localization/IStrings';
import { QuickFilter } from '../PurchasesCard';

export const createQfRecord = (strings: IStrings): Record<QuickFilter, string> => {
	return {
		all: strings.all,
		withOutstandingBalance: strings.withOutstandingBalance,
	};
};
